import { GpsAndBorderCrossingConfigurationModel } from '@/modules/settings/pages/gps/types';

export const mockedGpsData : GpsAndBorderCrossingConfigurationModel = {
    countryAliasesWithMinWage: 'FR,DE,NL',
    restActivityAliases: 'REST,PAUSE',
    drivingActivityAliases: 'DRIVE,WORK',
    tmsUnloadTime: '23:59',
    showAutomaticBorderCrossings: true,
    hideSameCountryCrossings: false,
    hideSameCountryCrossingThresholdMin: 10,
    showGpsCrossingsTogether: true,
};
